import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Tooltip, IconButton } from '@material-ui/core';
import { Check as CheckIcon, Close as CloseIcon, Edit as EditIcon } from '@material-ui/icons';

class MiniFormEditButton extends PureComponent {
    static propTypes = {
        handleEdit: PropTypes.func.isRequired,
        confirmEdit: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool.isRequired,
        formDisabled: PropTypes.bool.isRequired,
        hasRightToEdit: PropTypes.bool.isRequired,
        loading: PropTypes.bool,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        classes: PropTypes.object.isRequired
    };
    static defaultProps = {
        loading: false
    };

    render() {
        const { loading, handleEdit, confirmEdit, sendLoading, formDisabled, classes, hasRightToEdit, children } = this.props;

        if (loading) {
            return (
                <div className={classes.loadingContainer}>
                    <CircularProgress size={25} />
                </div>
            );
        }

        return (
            <div className={classes.containerMiniForm}>
                {hasRightToEdit && (
                    <div className={classes.miniFormEditButtonContainer}>
                        {!sendLoading ? (
                            <div className={classes.iconButtonContainer}>
                                {formDisabled ? (
                                    <Tooltip title={Translator.translate('general.edit')} placement="top">
                                        <IconButton
                                            className={classes.iconButtonMainStyle}
                                            aria-label={Translator.translate('general.edit')}
                                            size="small"
                                            onClick={handleEdit}
                                        >
                                            <EditIcon className={classes.editIconStyle} />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <React.Fragment>
                                        <Tooltip title={Translator.translate('general.cancel')} placement="top">
                                            <IconButton
                                                className={classes.iconButtonWhiteStyle}
                                                aria-label={Translator.translate('general.edit')}
                                                onClick={handleEdit}
                                                size="small"
                                            >
                                                <CloseIcon className={classes.closeIconStyle} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={Translator.translate('general.save')} placement="top">
                                            <IconButton
                                                className={classes.iconButtonMainStyle}
                                                aria-label={Translator.translate('general.edit')}
                                                onClick={confirmEdit}
                                                size="small"
                                            >
                                                <CheckIcon className={classes.checkIconStyle} />
                                            </IconButton>
                                        </Tooltip>
                                    </React.Fragment>
                                )}
                            </div>
                        ) : (
                            <div className={classes.iconButtonWhiteStyle}>
                                <CircularProgress size={20} />
                            </div>
                        )}
                    </div>
                )}
                {children}
            </div>
        );
    }
}

const styles = theme => ({
    loadingContainer: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    containerMiniForm: {
        position: 'relative',
        width: '100%'
    },
    miniFormEditButtonContainer: {
        position: 'absolute',
        top: 7,
        left: -24
    },
    iconButtonContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    closeIconStyle: {
        color: theme.palette.error.main,
        fontSize: 15
    },
    iconButtonWhiteStyle: {
        backgroundColor: theme.palette.common.white,
        padding: 3
    },
    iconButtonMainStyle: {
        backgroundColor: theme.palette.primary.main,
        padding: 3
    },
    editIconStyle: {
        color: theme.palette.common.white,
        fontSize: 15
    },
    checkIconStyle: {
        color: theme.palette.common.white,
        fontSize: 15
    }
});

export default withStyles(styles, { withTheme: true })(MiniFormEditButton);



// WEBPACK FOOTER //
// ./data/components/FHEMiniFormEditButton.js